module.exports = __webpack_public_path__ + "static/media/apartment3.94d0a764.jpg";